import React from "react";
import {
  AppStoreDownloadLink,
  Images,
  PlayStoreDownloadLink,
  Strings,
} from "../../utils/constant";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import "./style.css";
import { applyHoverAnimation } from "../../utils/animation";
import { useDeviceType } from "../../utils/isMobileHook";

gsap.registerPlugin(SplitText, useGSAP);

const Hero = () => {
  const sectionRef = React.useRef<HTMLDivElement>(null);
  const headingRef = React.useRef<HTMLHeadingElement[]>([]);
  const floatingTween = React.useRef<gsap.core.Tween | null>(null);
  const { isMobile } = useDeviceType();

  useGSAP(
    () => {
      const tl = gsap.timeline({
        defaults: { duration: 0.5 },
        delay: 3, // ⬅️ Initial delay before starting
      });

      tl.from(".hero-container", { opacity: 0, y: -50 })
        .from(".logo-image", { opacity: 0, y: -20 }, "<")
        .from(".hero-paragraph", { opacity: 0, y: 20 }, "<")
        .from(
          ".download-image-button",
          { opacity: 0, y: 20, stagger: 0.1 },
          "<"
        )
        .from(".dot-image", { opacity: 0, y: 20 }, "<")
        .from(
          ".hero-mobiles",
          { opacity: 0, x: -50, duration: 1, ease: "power3.out" },
          "<"
        );

      floatingTween.current = gsap.to(".hero-mobiles", {
        y: -25,
        duration: 1.5,
        ease: "power1.inOut",
        yoyo: true,
        repeat: -1,
      });
      applyHoverAnimation(".hero-mobiles", floatingTween);
      gsap.from(headingRef.current, {
        y: "8vw",
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        stagger: 0.1,
        delay: 3, // ⬅️ Delay matches the timeline
      });
    },
    { scope: sectionRef }
  );

  return (
    <section id="home" ref={sectionRef} className="hero-container">
      <div className="lines-image"></div>
      <header className="hero-header">
        <a href="/">
          <img
            src={Images.logo}
            className="logo-image"
            alt="dive buddies logo"
          />
        </a>
      </header>
      <main className="hero-main">
        <div className="hero-left ">
          {/* <div className="overflow-hidden">
            <p className="hero-paragraph">{Strings.AboveAndBeyond}</p>
          </div> */}

          <div className="hero-heading-container">
            {Strings.heroHeading(isMobile).map((text, index) => (
              <div className="overflow-hidden" key={index}>
                <h1
                  ref={(el) => {
                    if (el) {
                      headingRef.current[index] = el;
                    }
                  }}
                  className="hero-heading"
                >
                  {text}
                </h1>
              </div>
            ))}
          </div>
          <div className="hero-download-buttons">
            <a
              href={PlayStoreDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Images.playStoreBtn}
                alt="play store button"
                className="download-image-button"
              />
            </a>
            <a
              href={AppStoreDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Images.appStoreBtn}
                alt="app store button"
                className="download-image-button"
              />
            </a>
          </div>
          <img src={Images.dotImage} alt="dots" className="dot-image" />
        </div>
        <div className="hero-right ">
          <img
            src={Images.dotImage}
            className="hero-dot-image"
            alt="dot-image"
          />
          <img
            src={Images.boxImage}
            className="hero-box-image"
            alt="box-image"
          />
          <img
            src={Images.heroMobiles}
            loading="lazy"
            className="hero-mobiles"
            alt="mobile app screenshots"
          />
        </div>
      </main>
    </section>
  );
};

export default Hero;
